import React from 'react';
import { Spin } from 'antd';
import './StarterMessages.css';

export interface StarterMessageItem {
  id: string;
  icon: string;
  text: string;
}

interface StarterMessagesProps {
  messages: StarterMessageItem[];
  onMessageClick: (messageText: string) => void;
  loadingMessageId: string | null;
}

const StarterMessages: React.FC<StarterMessagesProps> = ({ 
  messages, 
  onMessageClick, 
  loadingMessageId 
}) => {
  return (
    <div className="starter-messages">
      {messages.map((message) => (
        <div 
          key={message.id}
          className={`starter-message ${loadingMessageId === message.id ? 'loading' : ''}`}
          onClick={() => !loadingMessageId && onMessageClick(message.text)}
        >
          <div className="starter-message-content">
            <span className="starter-message-icon">{message.icon}</span>
            <span className="starter-message-text">{message.text}</span>
            {loadingMessageId === message.id && (
              <Spin size="small" className="starter-message-loading" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StarterMessages;